import CantileverButton, { EditButton } from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import { CancelAndSaveContainer } from 'features/assetDatabase/utils/sharedStyles'
import React from 'react'

export interface FormHeaderProps {
  saveCancelButtons: boolean
  inCreateMode?: boolean
  formRef?: React.RefObject<HTMLFormElement>
  handleSave: (formRef?: React.RefObject<HTMLFormElement>) => void
  handleEdit: (formId: string) => void
  handleCancel: (formId: string) => void
  handleAdd?: () => void
  handleNonFormSave?: () => void
  formID: string
}
export const EditSaveCancelButtons: React.FC<FormHeaderProps> = ({
  saveCancelButtons,
  inCreateMode = false,
  formRef,
  handleSave,
  handleEdit,
  handleCancel,
  handleAdd,
  handleNonFormSave,
  formID,
}) => {
  return (
    <>
      {inCreateMode ? (
        <CancelAndSaveContainer>
          <CantileverButton primary onClick={() => handleSave(formRef)}>
            Create
          </CantileverButton>
        </CancelAndSaveContainer>
      ) : saveCancelButtons ? (
        <CancelAndSaveContainer>
          {handleAdd && (
            <CantileverButton onClick={handleAdd}>Add</CantileverButton>
          )}
          <CantileverButton onClick={() => handleCancel(formID)}>
            Cancel
          </CantileverButton>
          <CantileverButton
            primary
            onClick={() =>
              handleNonFormSave ? handleNonFormSave() : handleSave(formRef)
            }>
            Save
          </CantileverButton>
        </CancelAndSaveContainer>
      ) : (
        <CantileverCard.HiddenUnlessHovering>
          <EditButton ghost onClick={() => handleEdit(formID)} />
        </CantileverCard.HiddenUnlessHovering>
      )}
    </>
  )
}
